module.exports = __webpack_public_path__ + "img/2.aa4d7d1c.png";